<template>
  <div>
    <GalleryFormGroup
        v-model="data.image_id"
        name="image_id"
        label="Image"
        :error="(errors.image_id || [])[0]"
        :company-id="companyId"
    />

    <TextFormGroup
        v-model="data.text"
        name="text"
        label="Text"
        :error="(errors.text || [])[0]"
    />
  </div>
</template>

<script>
import GalleryFormGroup from "../../../../components/FormGroups/Block/Gallery"
import TextFormGroup from "../../../../vendor/forms/FormGroups/Block/Text"

export default {
  components: {GalleryFormGroup, TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    },

    companyId: {
      required: false,
    },
  },

  computed: {
    data: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
